import { observer } from "mobx-react-lite";
import React, { SyntheticEvent, useState } from "react";
import { Button, Card, Grid, Header, Image, Tab, Icon } from "semantic-ui-react";
import FotoUploadWidget from "../../app/common/imageUpload/FotoUploadWidget";
import { Foto, Profile } from "../../app/models/profile";
import { useStore } from "../../app/stores/store";
import "../profiles/ProfileFotos.css"

interface Props {
    profile: Profile;
}


export default observer(function ProfileFotos({profile}: Props){
    const {profileStore: {isCurrentUser, uploadFoto, uploading, loading, setMainFoto, deleteFoto}} = useStore();
    const [addFotoMode, setAddFotoMode] = useState(false);
    const [target, setTarget] = useState('');

    function handleFotoUpload(file : Blob) {
        uploadFoto(file).then(() => setAddFotoMode(false));
    }

    function handleSetMainFoto(foto: Foto, e: SyntheticEvent<HTMLButtonElement>) {
        setTarget(e.currentTarget.name);
        setMainFoto(foto);
    }

    function handleDeleteFoto(foto: Foto, e: SyntheticEvent<HTMLButtonElement>) {
        setTarget(e.currentTarget.name);
        deleteFoto(foto);
    }
    

    return (
        <Tab.Pane>
            <Grid>
                <Grid.Column width={16}>
                    <h1 className="fotos-title">Fotos</h1>
                    {(profile.fotos?.length != 0  && !addFotoMode) && (
                            <>
                                
                                <Card.Group className="foto-grid-body" itemsPerRow={4}>
                                    {profile.fotos?.map(foto => (
                                        <Card key={foto.id}>
                                            <Image className="foto-grid" src={foto.url} />
                                            {isCurrentUser && (
                                                <Button.Group fluid widths={2}>
                                                    <Button
                                                        animated ="vertical"
                                                        color='green'
                                                        name={'main' + foto.id}
                                                        disabled={foto.isMain}
                                                        loading={target === 'main' + foto.id && loading}
                                                        onClick={e => handleSetMainFoto(foto, e)} 
                                                    >
                                                        <Button.Content visible>
                                                            Usar como principal
                                                        </Button.Content>
                                                        <Button.Content hidden>
                                                            <Icon name="checkmark" />
                                                        </Button.Content>
                                                    </Button>
                                                    <Button 
                                                        animated="vertical"
                                                        color='red'
                                                        loading={target === foto.id && loading}
                                                        onClick={e => handleDeleteFoto(foto, e)} 
                                                        disabled={foto.isMain}
                                                        name={foto.id}
                                                    >
                                                        <Button.Content visible>
                                                            Eliminar
                                                        </Button.Content>
                                                        <Button.Content hidden>
                                                            <Icon name="trash" />
                                                        </Button.Content>
                                                    </Button>
                                                </Button.Group>
                                            )}
                                        </Card>
                                    ))}
                    
                                </Card.Group>
                            </>
                        )}
                </Grid.Column>
                
                {(addFotoMode || profile.fotos?.length == 0) && 
                    <Grid.Column width={16}>
                        <FotoUploadWidget uploadFoto={handleFotoUpload} loading={uploading} />
                    </Grid.Column>}
                
                {isCurrentUser && (
                            <div className="contenedor-boton">
                            {profile.fotos?.length != 0 && 
                                <Button  primary
                                    className={addFotoMode ? "boton-cancelar" : "boton-agregar"}
                                    content={addFotoMode ? 'Cancelar' : 'Agregar Foto'}
                                    onClick={() => setAddFotoMode(!addFotoMode)}
                                    />}
                            </div>
                )}
            </Grid>
        </Tab.Pane>
    )
})